import * as React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip, IconButton, Card, Typography } from '@mui/material';

import { CurrencyFormat } from '@ha/intl';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { ListingDetailsContext } from '../../ListingDetailsContext';

import styles from './RentalCosts.module.css';

export const RentalCosts = () => {
  const { T, formatCurrency, locale } = useIntl();
  const { listingDetails } = ListingDetailsContext.useContext();

  const deposit = listingDetails.deposit
    ? formatCurrency(
        listingDetails.deposit * 100,
        'EUR',
        CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION,
      )
    : '---';

  const totalRentalPrice = listingDetails.totalRentalPrice
    ? formatCurrency(
        listingDetails.totalRentalPrice * 100,
        'EUR',
        CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION,
      )
    : '---';

  const additionalCost = listingDetails.agencyFee
    ? formatCurrency(
        listingDetails.agencyFee * 100,
        'EUR',
        CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION,
      )
    : '---';

  const additionalCostDescription =
    locale === Locale.en
      ? listingDetails.agencyFeeDescriptionEN
      : listingDetails.agencyFeeDescriptionNL;
  return (
    <section className={styles.root} id="cost-breakups">
      <Typography className={CommonStyles.margin_bottom_2} variant="h5">
        {T('ldp.what_you_pay')}
      </Typography>
      <Card className={styles.card}>
        <div className={styles.cardRow}>
          <Typography variant="body2">
            {listingDetails.utilitiesIncluded
              ? T('ldp.what_you_pay.rent_and_utilities')
              : T('lbl.rent_excl_utilities')}
          </Typography>
          <Typography variant="subtitle2">{totalRentalPrice}</Typography>
        </div>
        <div className={styles.cardRow}>
          <Typography variant="body2">{T('LBL_DEPOSIT')}</Typography>
          <Typography variant="subtitle2">{deposit}</Typography>
        </div>
        <div className={styles.cardRow}>
          <div className={styles.additionalInfo}>
            <Typography variant="body2">
              {T('LBL_RD_ADDITIONAL_COSTS')}
            </Typography>
            <Tooltip
              color="secondary"
              title={
                <NavLink.Native
                  href="https://kamernet.nl/tips/international-students/housing/what-additional-costs-can-be-charged-when-renting-out-a-home"
                  underline="none"
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: T(
                        'ldp.what_you_pay.additional_costs.tooltip_copy',
                      ),
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: T(
                        'ldp.what_you_pay.additional_costs.tooltip_link',
                      ),
                    }}
                  />
                </NavLink.Native>
              }
            >
              <IconButton>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          </div>

          <Typography variant="subtitle2">{additionalCost}</Typography>
        </div>
        <div className={styles.additionalCostCaption}>
          <Typography variant="caption">{additionalCostDescription}</Typography>
        </div>
      </Card>
    </section>
  );
};
